import type { EntryPoint, RequestOrigin, SourceMfe } from '@servicetitan/financing-api-client';

export interface FinancingAttribution {
    origin?: RequestOrigin;
    entryPoint?: EntryPoint;
    sourceMfe?: SourceMfe;
    provider?: string;
}

let financingAttribution: FinancingAttribution = {};

const publishFinancingAttribution = (attribution: FinancingAttribution) => {
    window.DD_RUM?.setGlobalContextProperty?.('financingAttribution', attribution);
};

export const getFinancingAttribution = () => financingAttribution;

export const setFinancingAttribution = (partial: Partial<FinancingAttribution>) => {
    financingAttribution = {
        ...financingAttribution,
        ...(partial.origin !== undefined ? { origin: partial.origin } : {}),
        ...(partial.entryPoint !== undefined ? { entryPoint: partial.entryPoint } : {}),
        ...(partial.sourceMfe !== undefined ? { sourceMfe: partial.sourceMfe } : {}),
        ...(partial.provider !== undefined ? { provider: partial.provider } : {}),
    };
    publishFinancingAttribution(financingAttribution);
};

export const resetFinancingAttribution = () => {
    financingAttribution = {};
};
